import { styled } from '@mui/material';

import { ActionWebReport } from '../ActionWebReport';
import { ActionTestWithHumans } from '../ActionTestWithHumans';
import { ActionRunAgain } from '../ActionRunAgain';

const StyledActions = styled('footer')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  width: '100%',
  paddingTop: theme.spacing(4),
}));

export const Actions = () => {
  return (
    <StyledActions>
      <ActionWebReport />
      <ActionRunAgain />
      <ActionTestWithHumans />
    </StyledActions>
  );
};
